import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyC2EXBOFlKgG4BvWYM3QZrFtK_RjiDlrsg",
  authDomain: "devlifeworld.firebaseapp.com",
  projectId: "devlifeworld",
  storageBucket: "devlifeworld.appspot.com",
  messagingSenderId: "501728810200",
  appId: "1:501728810200:web:935f56ba3b76b2d4c873ad",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const database = firebaseApp.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider, storage };

export default database;
